import api from './api';

export function getSolicitations(idAdvisor) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/asesores/${idAdvisor}/creditos`);
}

export function getCreditsBy(idAdvisor,varcausalestado) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/asesores/${idAdvisor}/canalestado/${varcausalestado}/creditos`);
}

export function getCreditsToCancel(idAdvisor) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/asesores/${idAdvisor}/creditos-anular`);
}

export function getSolicitationById(idCredit) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/credits/${idCredit}/request-data`)
}

export function getCreditsWithPendingDocuments(idAdvisor) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/asesores/${idAdvisor}/creditosAdjuntar`);
}

export function getCreditsWithPendingIdentityValidation(idAdvisor) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/asesores/${idAdvisor}/canalestado/digicredito/creditos-validacion`);
}

export function getCreditsWithPendingIdentityValidationDirector(idAdvisor) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/asesores/${idAdvisor}/canalestado/creditos-validacion`);
}

export function getStatusById(idCredit) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/credits/status/${idCredit}`)
}